import {
    useIntervalFn,
} from '@vueuse/core';
import {
    ref,
} from 'vue';
import * as heartbeatService from '../services/heartbeat';
import {
    useAuth,
} from '../stores/auth-store';
import { useApplicationStore } from '../stores/application-store';

const REGULAR_HEARTBEAT_INTERVAL = 60 * 1000; // Every minute
const HEARTBEAT_INTERVAL_ON_ERROR = 5 * 60 * 1000; // Every five minutes

export function useHeartbeat() {
    const applicationStore = useApplicationStore();

    const heartbeatInterval = ref(REGULAR_HEARTBEAT_INTERVAL);

    async function checkHeartbeat() {
        const auth = useAuth();
        if (auth.isLoggedIn) {
            try {
                await heartbeatService.tick(applicationStore.applicationUuid);
                heartbeatInterval.value = REGULAR_HEARTBEAT_INTERVAL;
            } catch {
                // If an error happened (e.g. ERR_INTERNET_DISCONNECTED, HTTP 500) or the session expired,
                // retry the heartbeat after a certain back-off time.
                heartbeatInterval.value = HEARTBEAT_INTERVAL_ON_ERROR;
            }
        }
    }

    const { pause, resume, isActive } = useIntervalFn(checkHeartbeat, heartbeatInterval);

    return {
        pause, resume, isActive,
    };
}
